<!-- Header -->

<div [@navigationMaxMin]="navigationMinimize ? 'max' : 'min'"
     *ngIf="Session.valid && !isInsightsView"
     class="app-header">
  <div class="fa-pull-left center" style="padding-top: 8px; padding-left: 5px">
    <ul class="list-unstyled list-inline pointer">
      <li>
        <span class="fa-bars-width" (click)="changeNavigation()">
          <i class="fas fa-bars fa-2x" [margin-left]="10" style="width:22px;"></i>
        </span>
      </li>
      <li>
        <span class="fa-bars-width"
              [routerLink]="'home'"
              routerLinkActive="active">
          <i class="fas fa-home fa-2x" [margin-left]="10" style="width:27px;"></i>
        </span>
      </li>
      <li>
        <span *ngIf="environment && environment.portalCode == 'PDP'"
              [padding-left]="10"
              [padding-top]="5"
              class="font-size-menu display-block bold"
              [margin-right]="73"
              [routerLink]="'home'"
              routerLinkActive="active">
          PayDay Portal
        </span>
        <span *ngIf="environment && environment.portalCode == 'PAP'"
              [padding-left]="10"
              [padding-top]="5"
              [margin-right]="20"
              class="font-size-menu display-block bold"
              [routerLink]="'home'"
              routerLinkActive="active">
          PayDay Admin Portal
        </span>
      </li>
      <li>
        <span *ngIf="!navigationMinimize"
              [padding-top]="9"
              class="fa-pull-right pointer"
              (click)="changeNavigation()">
          <i class="fas fa-angle-left"></i>
        </span>
      </li>
      <li>
        <span *ngIf="
            environment &&
            environment.portalCode == 'PDP' &&
            Session.menu.menuItems &&
            Session.menu.menuItems.selected &&
            Session.menu.menuItems.selected.pages.selected &&
            Session.menu.menuItems.selected.pages.selected.data &&
            Session.menu.menuItems.selected.pages.selected.data.customerName
          "
              [padding-left]="10"
              [padding-top]="5"
              class="font-size-menu uppercase display-block">
          @
          {{ Session.menu.menuItems.selected.pages.selected.data.customerName }}
        </span>
      </li>
      <li>
        <span *ngIf="serviceStatusMessage"
              class="service-message service-message-container"
              (click)="showServiceStatusMessages($event)">
          <i *ngIf="serviceStatusMessage && serviceStatusMessage.length == 1"
             class="fas fa-exclamation-triangle"
             (click)="showServiceStatusMessages($event)">
          </i>
          <span *ngIf="serviceStatusMessage && serviceStatusMessage.length > 1"
                class="system-message-badge"
                (click)="showServiceStatusMessages($event)">
            {{serviceStatusMessage.length}}
          </span>
          {{serviceStatusMessage[0].Message}}
        </span>
      </li>
      <li>
    </ul>
  </div>
  <div class="fa-pull-right display-flex height-max">

    <div *ngIf="showVideo" class="toolbar-item">
      <img (click)="clickVideo($event)" src="../assets/icons/VIDEO_ICON.png" />

      <span class="toolbar-text pointer" (click)="clickVideo($event)">{{ "general.videoHelp" | gstranslate }}</span>
      <p-inputSwitch class="ui-inputwrapper-focus ui-inputwrapper-focus video-switch"
                     (ngModelChange)="changeVideoVisibility($event)"
                     [ngModel]="showVideoIcons"></p-inputSwitch>
    </div>

    <!-- AI-Insights toolbar entry (Insights V2 #27147). Mockup mxv-trigger
         pill: indigo→cyan gradient, inline diamond/sparkle SVG, amber pulse
         dot. Visibility gated to internal roles (Admin/Sales/GratSyncUser =
         RoleIds 1/2/3, see INSIGHTS_ROLE_IDS) via `canSeeInsights`
         (Session.roleIds from the login response's RoleIds). The insights
         default-landing override is gated the same way in security.helper.ts. -->
    <div class="toolbar-item iv2-toolbar" *ngIf="canSeeInsights">
      <!-- Tooltip lives on the wrapper span, not the button: the button's native
           type="button" attribute would bind to GSHeaderTooltip's @Input() type,
           overriding the default 'info' and dropping the gs-tooltip-info styling
           (white-on-white text). -->
      <span class="iv2-trigger-tooltip" gsHeaderTooltip="Open PDP AI-Insights view" anchor="host">
      <button type="button"
              class="iv2-trigger pointer"
              (click)="openInsights($event)">
        <span class="iv2-trigger-icon" aria-hidden="true">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 2 L13.6 8.4 L20 10 L13.6 11.6 L12 18 L10.4 11.6 L4 10 L10.4 8.4 Z"/>
            <path d="M19 16 L19.7 18 L21.5 18.7 L19.7 19.4 L19 21.5 L18.3 19.4 L16.5 18.7 L18.3 18 Z"/>
          </svg>
        </span>
        <span class="iv2-trigger-text">AI-Insights</span>
        <span class="iv2-trigger-pulse" aria-hidden="true"></span>
      </button>
      </span>
      <p-inputSwitch class="ui-inputwrapper-focus ui-inputwrapper-focus video-switch"
                     [ngModel]="insightsAsDefault"
                     (ngModelChange)="setInsightsAsDefault($event)"
                     gsHeaderTooltip="Open Insights by default on login" anchor="host"></p-inputSwitch>
    </div>

    <div *ngIf="showHelp" class="toolbar-item pointer" (click)="clickHelp($event)">
      <i class="fas fa-question-circle toolbar-icon" #videoButton></i>
      <span class="toolbar-text">{{ "general.helpDocument" | gstranslate }}</span>
    </div>

    <div class="toolbar-item pointer" (click)="user.toggle($event)">
      <i class="far fa-user toolbar-icon"></i>
      <div class="toolbar-text">
        <span>{{ Session.userName }} </span>
        <i [padding-top]="5" class="right fas fa-angle-down toolbar-icon"></i>
      </div>
    </div>

    <div class="notification-container toolbar-item" >
      <div [class.selected-notification-container]="showNotificationSidebar">
        <img class="notification-image" [class.selected-nav-icon]="showNotificationSidebar" (click)="onToogleNotification()" src="../assets/icons/megaphone.png" />
      </div>
      <span *ngIf="unreadNotificationCount > 0" class="notification-badge">
        {{ unreadNotificationCount }}
      </span>
    </div>

    <div class="toolbar-item pointer"
         (click)="confirm($event)"
         [type]="'info'"
         gsHeaderTooltip="{{ 'general.logoutTooltipMsg' | gstranslate }}"
         anchor="host"
         >
      <p-confirmPopup
      acceptLabel="Yes"
      rejectLabel="No"
      acceptButtonStyleClass="edit"
      [rejectButtonStyleClass]="'edit'"
      >

      </p-confirmPopup>
      <i class="fas fa-sign-out-alt toolbar-icon"></i>
    </div>
  </div>
</div>

<!-- /.Header -->

<div [@minMax]="navigationMinimize ? 'min' : 'max'"
     *ngIf="Session.valid && Session.menu && !isInsightsView"
     class="navigation sidebar">

  <!-- Sidebar Menu -->
  <nav class="mt-2 nav-width">
    <ul class="nav nav-pills nav-sidebar flex-column" id="sidebarMenu" data-widget="treeview" role="menu" data-accordion="false">
      <ng-container *ngFor="let menuItem of Session.menu.menuItems.values">

        <li class="nav-item nav-menu">
          <span *ngIf="menuItem.pages.values.length == 1"
                class="nav-link active nav-link-menu uppercase"
                (click)="toggleClass($event,'menu-open');showNavigation();"
                [routerLink]="menuItem.pages.values[0].route"
                routerLinkActive="active">
            <span gsHeaderTooltip="{{ navigationMinimize ? (menuItem.data.Title | uppercase) : '' }}" position="right">
              <i class="nav-icon {{ menuItem.data.Icon }}"></i>
            </span>
            <span class="nav-link-menu-title">{{ menuItem.data.Title }}</span>
            <i class="right fas fa-angle-left"></i>
          </span>

          <span *ngIf="menuItem.pages.values.length > 1"
                class="nav-link active nav-link-menu uppercase"
                (click)="toggleClass($event,'menu-open');showNavigation();">
            <span gsHeaderTooltip="{{ navigationMinimize ? (menuItem.data.Title | uppercase) : '' }}" position="right">
              <i class="nav-icon {{ menuItem.data.Icon }}"></i>
            </span>
            <span class="nav-link-menu-title">{{ menuItem.data.Title }}</span>
            <span *ngIf="hasSupportSubPage(menuItem) && Session.supportTicketCount > 0"
                  class="support-nav-badge">{{ Session.supportTicketCount }}</span>
            <i class="right fas fa-angle-left"></i>
          </span>

          <ul class="nav nav-treeview {{hidden}}">
            <ng-container *ngFor="let page of menuItem.pages.values">
              <li class="nav-item nav-link-page" [ngClass]="{ 'page-selected': page.selected }">
                <span *ngIf="page.route != 'help/documents'"
                      class="nav-link active"
                      [ngClass]="{ 'page-selected': page.selected }"
                      [routerLink]="page.route"
                      routerLinkActive="active"
                      appVideoTraining
                      [type]="page | pageTrainingVideo">
                  <span>
                    <i class="left fas fa-angle-right"></i>
                    {{ page.title }}
                    <span *ngIf="page.route === 'help/support' && Session.supportTicketCount > 0"
                          class="support-nav-badge">{{ Session.supportTicketCount }}</span>
                  </span>
                </span>
                <span *ngIf="page.route == 'help/documents'"
                      class="nav-link active"
                      [ngClass]="{ 'page-selected': page.selected }"
                      (click)="clickHelp($event, true)">
                  <span>
                    <i class="left fas fa-angle-right"></i>
                    {{ page.title }}
                  </span>
                </span>
            </ng-container>
          </ul>
        </li>
      </ng-container>
    </ul>
  </nav>
  <!-- /.sidebar-menu -->

</div>
<div [@contentMaxMin]="navigationMinimize ? !Session.valid ? 'maxLoggedOut' : 'max' : 'min'"
     class="app-content"
     #appContent
     [class.app-content-insights]="isInsightsView"
     [ngClass]="{
    'login-background': !Session.valid && environment.portalCode == 'PDP',
    'login-background-admin': !Session.valid && environment.portalCode == 'PAP'
  }">
  <router-outlet></router-outlet>

  <div *ngIf="
      Session.valid &&
      Session.menu &&
      environment.portalCode == 'PDP' &&
      !isInsightsView &&
      !showChatMenu &&
      !showChatGPT
    "
       style="
      position: fixed;
      bottom: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
      background-color: white;
      border: 4px solid rgb(0, 164, 78);
      cursor: pointer;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      border-bottom-left-radius: 30px;
      display: flex;
      justify-content: center;
      z-index: 5000;
      align-items: center;
    "
       (click)="openChatGPT()">
    <img src="../../../assets/images/chat_icon.png" width="16" height="15" />
    <!--<i class="fa fa-comments-o" aria-hidden="true" style="color: #00a44e; font-size: 20px; padding-top: 7px; font-weight: bold; "></i>-->
  </div>
  <div *ngIf="
      Session.valid &&
      Session.menu &&
      environment.portalCode == 'PDP' &&
      !isInsightsView &&
      (showChatMenu || showChatGPT)
    "
       style="
      position: fixed;
      bottom: 30px;
      right: 30px;
      width: 40px;
      height: 40px;
      background-color: white;
      border: 4px solid rgb(0, 164, 78);
      cursor: pointer;
      border-top-left-radius: 30px;
      border-top-right-radius: 30px;
      border-bottom-left-radius: 30px;
      display: flex;
      justify-content: center;
      z-index: 5000;
    "
       (click)="closeChat()">
    <i class="fa fa-chevron-down"
       aria-hidden="true"
       style="
        color: #1d3e7d;
        font-size: 16px;
        padding-top: 8px;
        font-weight: bold;
      "></i>
  </div>
  <!--<div *ngIf="Session.valid && Session.menu && environment.portalCode == 'PDP' && showChatMenu">
    <div style="position: fixed;bottom: 80px;right: 30px;width: 270px;height: 200px;border: 2px solid #efefef;border-radius: 10px;background-color: white;box-shadow: 0px 0px 4px 4px #cfcfcf;">
      <div style="border-bottom:1px solid #efefef; width:245px;height:40px;margin-left:10px; margin-right:10px;">
        <div style="float: left;font-weight: bold;color: black;padding-left: 5px;padding-top: 5px;">Hello {{ Session.userName }}</div>
        <div style="float:right"><img src="../favicon.ico" width="30px" height="30px" /></div>
      </div>
      <div class="chat-menu-link" (click)="openChatGPT()">
        <i class="fa fa-comments-o chat-menu-link-icon" aria-hidden="true"></i>Ask us a question
      </div>
      <div class="chat-menu-link">
        <i class="fa fa-question-circle-o chat-menu-link-icon" aria-hidden="true"></i>Documents (Read/Print)
      </div>
      <div class="chat-menu-link">
        <i class="fa fa-play-circle-o chat-menu-link-icon" aria-hidden="true"></i>Video Help (Watch)
      </div>
      <div class="chat-menu-link">
        <i class="fa fa-life-ring chat-menu-link-icon" aria-hidden="true"></i>Send us Support Ticket
      </div>
    </div>
  </div>-->
  <div *ngIf="
      Session.valid &&
      Session.menu &&
      environment.portalCode == 'PDP' &&
      !isInsightsView &&
      showChatGPT
    ">
    <div class="chat-gpt-box">
      <div style="
          width: 100%;
          height: 60px;
          background-color: #1d3e7d;
          border-top-left-radius: 20px;
          border-top-right-radius: 20px;
          padding: 10px 0px 0px 0px;
        ">
        <div style="
            width: 100%;
            color: white;
            font-weight: bold;
            text-align: center;
            padding-top: 7px;
          ">
          PayDayPortal AI Help Desk
        </div>
      </div>
      <!--<div style="width: 100%;  background-color: #1d3e7d;">
        <div style="width:100%; color:white; text-align:center; font-size:14px;">Hello, {{Session.userName}}!</div>
      </div>
      <div style="width: 100%;  background-color: #1d3e7d;">
        <div style="width:100%; color:white; text-align:center; font-size:14px;padding-bottom:10px;">How can we help you?</div>
      </div>-->
      <div>
        <div *ngIf="showChatGPTSpinner" class="chat-spiner-container">
          <div class="chat-spiner"
               style="background-color: white; border-radius: 50%">
            <img src="../../../assets/images/gs.logo.png"
                 style="padding: 15px"
                 width="100"
                 height="100" />
          </div>
        </div>

        <div style="height: 480px; overflow-y: scroll" #chatGPtHistory>
          <div style="
              display: flex;
              justify-content: left;
              float: left;
              width: 400px;
              font-size: 14px;
            ">
            <div style="
                display: flex;
                justify-content: left;
                background-color: #e6f5ec;
                margin: 10px 10px 5px 10px;
                border: 1px solid #e6f5ec;
                border-radius: 30px;
                padding: 10px 15px;
                font-size: 14px;
                width: 400px;
                color: black;
                white-space: pre-wrap;
              ">
              Hello, {{ Session.userName }}! How can we help you?
            </div>
            <div style="
                font-size: 11px;
                vertical-align: middle;
                justify-content: center;
                display: flex;
                align-content: center;
                flex-wrap: wrap;
              ">
              PDP
            </div>
          </div>
          <div *ngFor="let message of chatGPTMessages">
            <div *ngIf="message.Role == 'assistant'"
                 style="
                display: flex;
                justify-content: left;
                float: left;
                width: 400px;
                font-size: 14px;
              ">
              <div style="
                  display: flex;
                  justify-content: left;
                  background-color: #e6f5ec;
                  margin: 5px 10px 5px 10px;
                  border: 1px solid #e6f5ec;
                  border-radius: 30px;
                  padding: 10px 15px;
                  font-size: 14px;
                  width: 400px;
                  color: black;
                  white-space: pre-wrap;
                ">
                {{ message.Content }}
              </div>
              <div style="
                  font-size: 11px;
                  vertical-align: middle;
                  justify-content: center;
                  display: flex;
                  align-content: center;
                  flex-wrap: wrap;
                ">
                PDP
              </div>
            </div>

            <div *ngIf="message.Role == 'user'"
                 style="
                display: flex;
                justify-content: right;
                float: right;
                width: 400px;
                font-size: 14px;
              ">
              <div style="
                  font-size: 11px;
                  vertical-align: middle;
                  justify-content: center;
                  display: flex;
                  align-content: center;
                  flex-wrap: wrap;
                ">
                You
              </div>
              <div style="
                  display: flex;
                  justify-content: left;
                  background-color: #f1f1f1;
                  margin: 5px 10px 5px 10px;
                  border: 1px solid #f1f1f1;
                  border-radius: 30px;
                  padding: 10px 15px;
                  font-size: 14px;
                  width: 400px;
                  color: black;
                  white-space: pre-wrap;
                ">
                {{ message.Content }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-gpt-prompt"
           style="
          height: 60px;
          bottom: 80px;
          position: fixed;
          width: 450px;
          border-bottom-left-radius: 20px;
          border-bottom-right-radius: 20px;
          border-top: 1px solid #cccccc;
        ">
        <input class="chat-gpt-prompt-input"
               #chatGptPrompt
               type="text"
               id="chatGptPrompt"
               name="chatGptPrompt"
               (keyup.enter)="sendChatGPT()"
               style="
            color: #828282;
            position: fixed;
            bottom: 99px;
            width: 400px;
            margin-left: 2px;
            font-size: 14px;
            padding-left: 10px;
          "
               placeholder="Type your message..." />
        <!--<i class="fa fa-paper-plane-o" aria-hidden="true" style="position: fixed;bottom: 80px;right:30px;margin-right: 5px;margin-bottom: 5px;font-weight: bold;cursor:pointer;" (click)="sendChatGPT()"></i>-->
        <img src="../../../assets/images/send_chat.png"
             style="
            position: fixed;
            bottom: 78px;
            right: 30px;
            margin-right: 5px;
            margin-bottom: 15px;
            cursor: pointer;
          "
             width="35"
             height="35"
             (click)="sendChatGPT()" />
      </div>
    </div>
  </div>

  <!-- ===== AI ChatBot (AskChatBot) =====
       Extracted into its own component (ChatBotComponent). Gating stays here: valid
       session with a menu, not on the Insights view. PAP gets config / recon; PDP gets
       the uClock scheduling assistant, which the component offers only while a schedule
       builder is on screen (US-8.113). -->
  <app-chat-bot *ngIf="
      Session.valid &&
      Session.menu &&
      (environment.portalCode == 'PAP' || environment.portalCode == 'PDP') &&
      !isInsightsView
    "></app-chat-bot>
</div>
<!-- <div class="app-footer">
  <span class="footer-text">
    Protected by Patent Nos.# 9,741,050 and #10,726,436
  </span>
</div> -->

<p-toast #notification
         [baseZIndex]="5001"
         [styleClass]="!navigationMinimize ? 'toast-max' : ''"
         (onClose)="toastClosed($event)"></p-toast>

<p-overlayPanel #user>

  <div style="display: table-row; font-size: 13px">
    <div style="
       display: table-cell;
       font-weight: bold;
       border-bottom: 1px solid #b0b0b0;
       padding-bottom: 6px;">
      Roles: {{ Session.userRole }}
    </div>
  </div>

  <div *ngIf="
      Session.accountID &&
      Session.accountID != '' &&
      environment &&
      environment.portalCode == 'PDP'
    "
       style="display: table-row; font-size: 13px">
    <div style="
        display: table-cell;
        font-weight: bold;
        border-bottom: 1px solid #b0b0b0;
        padding-top: 6px;
        padding-bottom: 6px;
      ">
      {{ "general.accountID" | gstranslate }} {{ Session.accountID }}
    </div>
    <div class="pointer"
         style="
        display: table-cell;
        padding-left: 5px;
        border-bottom: 1px solid #b0b0b0;
        padding-bottom: 3px;
      "
         (click)="copyAccountID()">
      <i class="fas fa-clone"></i>
    </div>
  </div>
  <ul class="list-unstyled"
      style="min-width: 180px; padding-top: 10px; margin-bottom: 0px">
    <li *ngIf="showUserDetails" class="pointer" (click)="userDetails($event)">
      <ul class="list-inline">
        <li>
          <i class="fas fa-user"></i>
        </li>
        <li appVideoTraining
            [type]="TrainingVideos.ChangeAccountDetailsAndPassword">
          <span class="font-size-menu"> Details</span>
        </li>
      </ul>
    </li>

  </ul>
</p-overlayPanel>

<p-overlayPanel (onHide)="this.isHelpShown = false; this.isFromNavigation = false"
                [ngClass]="{ documents: isFromNavigation }"
                [showCloseIcon]="true"
                class="help"
                #help
                [style]="{ width: '80%', height: '90%' }"
                [styleClass]= "isFromNavigation ? 'user-manual-overlay panel-center' : 'panel-center'"
                >
  <app-user-manual *ngIf="isHelpShown"
                   [isFromNavigation]="isFromNavigation"
                   [showAll]="true"></app-user-manual>
</p-overlayPanel>

<!--<p-overlayPanel
  (onHide)="this.showTrainingVideo = false;"
  [ngClass]="{ documents: isFromNavigation }"
  [showCloseIcon]="true"
  class="help"
  #trainingVideos
  [style]="{ width: '80%', height: '90%' }"
  [dismissable]="false"
>
  <app-training-video *ngIf="showTrainingVideo"></app-training-video>
</p-overlayPanel>-->
<p-dialog [(visible)]="this.showTrainingVideo"
          [closable]="true"
          [ngClass]="{ documents: isFromNavigation }"
          [draggable]="false"
          [resizable]="false"
          [modal]="true"
          class="help"
          #trainingVideos
          [style]="{ width: '80%', height: '100%' }">
  <ng-template pTemplate="headless">
    <app-training-video *ngIf="showTrainingVideo"></app-training-video>
  </ng-template>
</p-dialog>

<p-dialog [(visible)]="this.showServiceStatusMessageDialog"
          [closable]="true"
          [ngClass]="{ documents: isFromNavigation }"
          (onHide)="serviceStatusMessageDialogClosed($event)"
          [draggable]="false"
          [resizable]="false"
          [modal]="true"
          header="Active service status messages"
          #serviceStatusMessages
          [style]="{ width: '80%' }">

  <gs-table #serviceStatusMessage
            *ngIf="serviceStatusMessageItem"
            change
            [pageSize]="10"
            [totalResultsCnt]="serviceStatusMessageItem.items.keys.length"
            [showPaginator]="true"
            [wide]="true"
            [columns]="serviceStatusMessageColumns"
            [items]="serviceStatusMessageItem.items">
  </gs-table>
</p-dialog>

<p-confirmDialog [baseZIndex]="10000"
                 header="Confirmation"
                 icon="pi pi-exclamation-triangle"></p-confirmDialog>
<ngx-spinner zIndex="5000"></ngx-spinner>
<app-spinner *ngIf="Session.showSpinner" zIndex="5000"></app-spinner>
<app-notification-overview
  *ngIf="notificationOverviewReady"
  [showNotificationSidebar]="showNotificationSidebar"
  (sidebarClosed)="onToogleNotification(true)"
  [appendTo]="appContent"
  >
</app-notification-overview>


<!-- G2 in-app review prompt (#28067). Opened by the PDP-4 inactivity trigger. -->
<g2-review-popup #g2Popup></g2-review-popup>
